import React from 'react';

import { useTranslation } from 'react-i18next';

import { CupFilledIcon } from '@icons';

import { useModals } from '@shared/contexts';

import { PromotionPrizeType } from '@types';

import { Button } from '@components/button';
import { ModalName } from '@components/modals';

import * as Styled from './prize-card.styled';

type OwnProps = {
	prize: PromotionPrizeType;
};

const PrizeCard: React.FC<OwnProps> = ({ prize }) => {
	const { t } = useTranslation('main');
	const { openModal } = useModals();

	const handleWinnersList = () => {
		openModal(ModalName.PROMOTION_WINNERS_LIST, { winnerList: prize.winners });
	};

	return (
		<Styled.Wrapper $bg={prize.image}>
			<Styled.PrizeName>
				<CupFilledIcon />
				{prize.name}
			</Styled.PrizeName>
			<Styled.ButtonWrapper>
				<Button onClick={handleWinnersList} color='dark'>
					{t('winners')}
				</Button>
			</Styled.ButtonWrapper>
		</Styled.Wrapper>
	);
};

export default PrizeCard;
